@let obs =
  {
    item: infoblock$ | async,
  };

@if (obs.item) {
  <sd-generic-link [url]="obs.item.link" (click)="onClick(obs.item)" [style.justifyContent]="obs.item.justifyContent">
    <div class="infoblock-wrapper">
      <sd-icon [type]="obs.item.icon" class="color-white icon-size-s icon-size-md-m"></sd-icon>
      <div class="link-white link-hover-white link-hover-underlined text-b3-s-500 text-md-b2-s-500">
        {{ obs.item.text }}
      </div>
    </div>
  </sd-generic-link>
}
